import React from "react";

import PasswordChangeFormContainer from "../components/PasswordChangeForm";
import AuthLayout from '../layouts/AuthLayout';
import { useTranslation } from 'react-i18next'

function SignUp() {
    const { t } = useTranslation('common')
    return (
        <AuthLayout title={t('auth.passwordChangeTitle')}>
            <PasswordChangeFormContainer /> 
        </AuthLayout>
    );
}

export default SignUp;
